import { Ref, ref } from 'vue';

const useDrag = (pdfCanvasContainer: Ref<HTMLElement | null>) => {
  const isGrabbing = ref(false);
  const grabStart = ref<{ x: number; y: number }>({ x: 0, y: 0 });
  const scrollStart = ref<{ left: number; top: number }>({ left: 0, top: 0 });

  const onGrabMove = (e: MouseEvent | TouchEvent) => {
    if (!isGrabbing.value || !pdfCanvasContainer.value) return;

    if ('touches' in e) {
      e.preventDefault();
    }

    const event = 'touches' in e ? e.touches[0] : e;
    const dx = event.clientX - grabStart.value.x;
    const dy = event.clientY - grabStart.value.y;

    pdfCanvasContainer.value.scrollLeft = scrollStart.value.left - dx;
    pdfCanvasContainer.value.scrollTop = scrollStart.value.top - dy;
  };

  const onGrabEnd = () => {
    isGrabbing.value = false;
    document.body.style.cursor = 'default';

    window.removeEventListener('mousemove', onGrabMove);
    window.removeEventListener('touchmove', onGrabMove);

    window.removeEventListener('mouseup', onGrabEnd);
    window.removeEventListener('touchend', onGrabEnd);
    window.removeEventListener('touchcancel', onGrabEnd);
  };

  const onGrabStart = (e: MouseEvent | TouchEvent) => {
    const event = 'touches' in e ? e.touches[0] : e;

    isGrabbing.value = true;
    grabStart.value = { x: event.clientX, y: event.clientY };

    if (pdfCanvasContainer.value) {
      scrollStart.value = {
        left: pdfCanvasContainer.value.scrollLeft,
        top: pdfCanvasContainer.value.scrollTop,
      };
    }

    document.body.style.cursor = 'grabbing';

    window.addEventListener('mousemove', onGrabMove);
    window.addEventListener('touchmove', onGrabMove, { passive: false });

    window.addEventListener('mouseup', onGrabEnd);
    window.addEventListener('touchend', onGrabEnd);
    window.addEventListener('touchcancel', onGrabEnd);
  };

  return {
    onGrabStart,
  };
};

export default useDrag;
